import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3;

import { observable, runInAction, computed, makeObservable, action } from "mobx";
import DPServices from "@dp/services";
import { PlatformType } from "@dp/common";
var UnavailableItemsModel = (_class = /*#__PURE__*/function () {
  function UnavailableItemsModel(platformUtil) {
    _classCallCheck(this, UnavailableItemsModel);

    _initializerDefineProperty(this, "_appAttributes", _descriptor, this);

    _initializerDefineProperty(this, "_unavailableProducts", _descriptor2, this);

    _initializerDefineProperty(this, "_displayUnavailableItemIssueModal", _descriptor3, this);

    _defineProperty(this, "platformUtil", void 0);

    this.platformUtil = platformUtil;
    this._displayUnavailableItemIssueModal = false;
    this._unavailableProducts = null;
    makeObservable(this);
  }

  _createClass(UnavailableItemsModel, [{
    key: "setAppAttributes",
    value: function setAppAttributes(_appAttributes) {
      var _this = this;

      runInAction(function () {
        _this._appAttributes = _appAttributes;
      });
    }
  }, {
    key: "submitErrorHandler",
    value: function submitErrorHandler(appMessages, errObj) {
      var handled = false;
      var parsed = DPServices.Cart.parseErrors(errObj);
      var faults = parsed === null || parsed === void 0 ? void 0 : parsed.faults;
      var unAvailableItems = parsed === null || parsed === void 0 ? void 0 : parsed.unAvailableItems;
      var productIds = [];
      var commerceIDs = [];

      if (faults && unAvailableItems) {
        unAvailableItems.forEach(function (item) {
          productIds.push(item.productId);
          commerceIDs.push(item.id);
        });
        this.setUnavailableProducts(faults[0].faultDescription, productIds, commerceIDs);
        this.setDisplayUnavailableItemIssueModal(true);

        if (this.platformUtil.PLATFORM_TYPE === PlatformType.APP) {
          this.platformUtil.navigateToRoute("/Cart");
        }

        handled = true;
      }

      return handled;
    }
  }, {
    key: "setUnavailableProducts",
    value: function setUnavailableProducts(faultDescription, itemName, commerceIds) {
      if (faultDescription && itemName) {
        this._unavailableProducts = {
          faultDescription: faultDescription,
          itemName: itemName,
          commerceIds: commerceIds
        };
      } else {
        this._unavailableProducts = null;
      }
    }
  }, {
    key: "setDisplayUnavailableItemIssueModal",
    value: function setDisplayUnavailableItemIssueModal(displayUnavailableItemIssueModal) {
      this._displayUnavailableItemIssueModal = displayUnavailableItemIssueModal;
    }
  }, {
    key: "unavailableProducts",
    get: function get() {
      return this._unavailableProducts;
    }
  }, {
    key: "displayUnavailableItemIssueModal",
    get: function get() {
      return this._displayUnavailableItemIssueModal;
    }
  }]);

  return UnavailableItemsModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_unavailableProducts", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_displayUnavailableItemIssueModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "unavailableProducts", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "unavailableProducts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setUnavailableProducts", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setUnavailableProducts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayUnavailableItemIssueModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayUnavailableItemIssueModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setDisplayUnavailableItemIssueModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setDisplayUnavailableItemIssueModal"), _class.prototype)), _class);
export { UnavailableItemsModel as default };